// extracted by mini-css-extract-plugin
export var header = "_j1-0";